import { type BasicCheckMerchantsResponse } from '@redteclab/api/clients/bully'

export const nowBasicCheckResponseAccessorIsCurrentVariantEligibleForPickup = (
  response: BasicCheckMerchantsResponse | undefined,
): boolean => {
  if (!response) {
    return false
  }

  return Boolean(response.nowEligiblePickup && response.zipCodeInPickupRegion)
}
